import { NextPage } from 'next'

import { PageBackgroundColor, SanityPage } from 'src/components/layouts/Page'
import { NativeTrees } from 'src/components/organisms/NativeTrees'

import { NavigationContext } from 'src/types/account'

export const NativeTreesPage: NextPage = () => {
  return (
    <SanityPage
      navigationContext={NavigationContext.Public}
      backgroundColor={PageBackgroundColor.linen}
      showHero={false}
      slug='native-trees'
      isFullWidth
    >
      {NativeTrees}
    </SanityPage>
  )
}
